import { ChatPromptInputType } from 'utils/chat/chatConstants';
import ChatPromptDecision from './ChatPromptDecision';

const ChatPromptDispatcher = ({ disabled, onSubmit, prompt, response }) => {
    if (!prompt) return null;

    const inputType = prompt.input_type || prompt.action_type || ChatPromptInputType.BINARY;

    switch (inputType) {
        case ChatPromptInputType.BINARY:
            return <ChatPromptDecision disabled={disabled} onSubmit={onSubmit} prompt={prompt} response={response} />;
        default:
            console.warn(`Unsupported chat prompt type: ${inputType}`);
            return null;
    }
};

export default ChatPromptDispatcher;
